import { type PageEntity, apiClient, type CustomerEntity } from '@/libs/api'
import { type CustomersRequestQuery } from '@/libs/api/types'

export type FetchCustomersQuery = {
  tenantKey: string
  query?: CustomersRequestQuery
}

export type FetchCustomersResponse = {
  data: CustomerEntity[]
  pagination: PageEntity | null
}

export const fetchCustomers = async (
  { tenantKey, query }: FetchCustomersQuery,
  signal?: AbortSignal
): Promise<FetchCustomersResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .customers.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
